import {
    withAppStyle,
    WithAppStyleProps,
} from '@cuatroochenta/co-admin-react-library'
import './FileIcon.scss'

const FileIcon = ({ appStyles }: WithAppStyleProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className="icon icon-tabler icons-tabler-filled icon-tabler-file"
            fill={appStyles.primaryColor}
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h5z" />
            <path d="M19 7h-4l-.001 -4.001z" />
        </svg>
    )
}

export default withAppStyle(FileIcon)
